module.exports = __webpack_public_path__ + "static/media/pm_campaign.873ee6f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/pm_campaign.png
// module id = 514
// module chunks = 0